import React from 'react';
import MdmPlatformCards from './MdmPlatformCards'
import { windowsSections } from './MdmData'
import './mdm.css'

const MdmWindowsDemo = () => {

  const url = new URL(window.location.href);

  return (
    <>
      <div className='mdm-page w-100 py-3' style={{ overflowX: 'hidden' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.location.href = `${url.origin}/demo/mdm`}>
            <span className="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to MDM</p>
          </div>
        </div>

        <div className='px-sm-5 px-3 mt-3 mb-5'>
          <MdmPlatformCards
            title="Windows Device Management"
            subtitle="Enrollment, device groups and BitLocker encryption policy."
            sections={windowsSections}
            active="windows"
          />
        </div>
      </div>
    </>
  )
}

export default MdmWindowsDemo
